import * as React from 'react';

interface ErrorListProps {
  title?: string;
  messages: string[];
}

export const ErrorList: React.VFC<ErrorListProps> = ({
  title = 'Please fix the following before continuing:',
  messages,
}) => {
  if (messages.length === 0) return null;

  return (
    <div
      role="alert"
      style={{
        padding: '1rem',
        border: '1px solid #c0392b',
        background: 'rgba(192, 57, 43, 0.05)',
        borderRadius: '4px',
      }}
    >
      <strong style={{ color: '#c0392b', display: 'block', marginBottom: '0.5rem' }}>{title}</strong>
      <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
        {messages.map((message, idx) => (
          <li key={idx}>{message}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorList;
